import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { Stat } from '../../types/landing';
type PackageHighlightsProps = {
  highlights: string[];
  stats: Stat[];
};
export function PackageHighlights({
  highlights,
  stats
}: PackageHighlightsProps) {
  return <section className="mx-auto mt-10 max-w-5xl px-6" data-id="element-30" data-mp="2qg0y59kof72e">
      <h2 className="text-center font-display text-lg italic text-ink" data-id="element-31" data-mp="2ugkvoe95wcp2">
        Everything handled, one package
      </h2>
      <ul className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-5" data-id="element-32" data-mp="2ze36ka6qp1zp">
        {highlights.map(item => <li key={item} className="flex items-start gap-2" data-id="element-33" data-mp="34bcutmie77ly">
            <CheckIcon className="mt-0.5 h-3 w-3 shrink-0 text-ink/70" aria-hidden="true" data-id="element-34" data-mp="395quw28022wy" />
            <span className="font-body text-[13px] leading-snug text-ink/80" data-id="element-35" data-mp="3e2ha6nbzcuhb">{item}</span>
          </li>)}
      </ul>

      <dl className="mt-6 grid grid-cols-2 gap-y-5 bg-sand px-4 py-5 md:grid-cols-5 md:gap-y-0" data-id="element-36" data-mp="3i6xfamdrrxvh">
        {stats.map((stat, i) => <div key={stat.label} className={`flex flex-col items-center text-center ${i > 0 ? 'md:border-l md:border-ink/15' : ''}`} data-id="element-37" data-mp="14y0c4mewk438" data-mpi={i}>
            <dt className="order-2 mt-1 font-sans text-[8px] font-medium uppercase tracking-[0.25em] text-ink/70" data-id="element-38" data-mp="vxak7tsrixus">
              {stat.label}
            </dt>
            <dd className="order-1 font-display text-2xl text-ink" data-id="element-39" data-mp="qzs9bxv6q8k5">{stat.value}</dd>
          </div>)}
      </dl>
    </section>;
}